var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.269 2.02344H2.85111C1.279 2.02344 0 3.30254 0 4.87468V15.2544C0 16.8265 1.279 18.1054 2.85111 18.1054H18.269C19.8411 18.1054 21.12 16.8265 21.12 15.2544V4.87468C21.1199 3.30257 19.8411 2.02344 18.269 2.02344ZM20.0309 15.2544C20.0309 16.2259 19.2405 17.0163 18.269 17.0163H2.85111C1.87948 17.0163 1.08902 16.2259 1.08902 15.2544V4.87468C1.08902 3.90292 1.87946 3.11246 2.85111 3.11246H18.269C19.2405 3.11246 20.031 3.90289 20.031 4.87468L20.0309 15.2544Z",
    fill: "#6A6C71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.0476 5.14844C10.3376 5.14844 8.13281 7.35332 8.13281 10.0634C8.13281 12.7734 10.3376 14.9781 13.0476 14.9781C15.7577 14.9781 17.9625 12.7734 17.9625 10.0634C17.9625 7.35332 15.7577 5.14844 13.0476 5.14844ZM13.0476 13.889C10.9382 13.889 9.22183 12.1728 9.22183 10.0634C9.22183 7.95367 10.9382 6.23746 13.0476 6.23746C15.1573 6.23746 16.8735 7.95367 16.8735 10.0634C16.8736 12.1728 15.1573 13.889 13.0476 13.889Z",
    fill: "#6A6C71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.31198 4.75781H3.79451C3.4938 4.75781 3.25 5.00162 3.25 5.30232C3.25 5.60303 3.4938 5.84683 3.79451 5.84683H5.31198C5.61268 5.84683 5.85649 5.60303 5.85649 5.30232C5.85649 5.00162 5.61268 4.75781 5.31198 4.75781Z",
    fill: "#6A6C71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6951 0H13.0484C12.7477 0 12.5039 0.243804 12.5039 0.54451C12.5039 0.845215 12.7477 1.08902 13.0484 1.08902H17.6951C17.9958 1.08902 18.2396 0.845215 18.2396 0.54451C18.2396 0.243804 17.9958 0 17.6951 0Z",
    fill: "#6A6C71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c2e35bac725e20adf29a7b6ed19c13fb.svg";
export { ForwardRef as ReactComponent };